// src/pages/BotPage.js

import React, { useState } from 'react';

export default function BotPage() {
  const [userInput, setUserInput] = useState('');
  const [output, setOutput]       = useState('');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setOutput('');

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/bots/1/run`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userInput })
        }
      );
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Falha');
      setOutput(data.output);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <h2>Acionar Bot IA #1</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="input" className="form-label">Seu texto:</label>
          <textarea
            id="input"
            className="form-control"
            rows="4"
            value={userInput}
            onChange={e => setUserInput(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Processando…' : 'Executar Bot'}
        </button>
      </form>

      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {output && (
        <div className="card mt-3">
          <div className="card-header">Resposta do Bot</div>
          <div className="card-body">
            <pre>{output}</pre>
          </div>
        </div>
      )}
    </div>
  );
}
